import styled from "styled-components";
import params from "../../global/params.json";

const containerParams = params.container;

export const Container = styled.div`
  max-width: ${containerParams.maxWDesktop};
  padding: 112px 32px 0 32px;
  width: 100%;
  margin: 0 auto;
  background: var(--background);
  .background-home {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    min-width: 1200px;
    z-index: -1;
  }
`;
